export const LANG_MAP: Record<string,string> = {
  HINDI: "hi",
  ENGLISH: "en",
  BENGALI: "bn",
  GUJARATI: "gu",
  TAMIL: "ta",
  TELUGU: "te",
  KANNADA: "kn",
  MALAYALAM: "ml",
  MARATHI: "mr",
  PUNJABI: "pa",
  ODIA: "or",
  ORIYA: "or",
  ASSAMESE: "as",
  URDU: "ur",
  SANSKRIT: "sa",
  SINDHI: "sd",
  NEPALI: "ne"
};
const _VIEW_MORE_TEXT: Record<string, string> = {
  HINDI: "पूरी खबर पढ़ें",
  ENGLISH: "Read full story",
  BENGALI: "সম্পূর্ণ খবর পড়ুন",
  GUJARATI: "સંપૂર્ણ સમાચાર વાંચો",
  TAMIL: "முழு செய்தியை படிக்கவும்",
  TELUGU: "పూర్తి వార్త చదవండి",
  KANNADA: "ಪೂರ್ಣ ಸುದ್ದಿ ಓದಿ",
  MALAYALAM: "മുഴുവൻ വാർത്ത വായിക്കുക",
  MARATHI: "संपूर्ण बातमी वाचा",
  PUNJABI: "ਪੂਰੀ ਖ਼ਬਰ ਪੜ੍ਹੋ",
  ODIA: "ସମ୍ପୂର୍ଣ୍ଣ ଖବର ପଢନ୍ତୁ",
  ORIYA: "ସମ୍ପୂର୍ଣ୍ଣ ଖବର ପଢନ୍ତୁ",
  ASSAMESE: "সম্পূৰ্ণ খবৰ পঢ়ক",
  URDU: "پوری خبر پڑھیں",
  SANSKRIT: "सम्पूर्णं वार्तां पठन्तु",
  SINDHI: "مڪمل خبر پڙهو",
  NEPALI: "पूरा खबर पढ्नुहोस्"
};

const _LANG_STRING: Record<string, string> = {
  BENGALI: "বাংলা",
  HINDI: "हिन्दी",
  MARATHI: "मराठी",
  ODIA: "ଓଡ଼ିଆ",
  TELUGU: "తెలుగు",
  KANNADA: "ಕನ್ನಡ",
  MALAYALAM: "മലയാളം",
  PUNJABI: "ਪੰਜਾਬੀ",
  GUJARATI: "ગુજરાતી",
  TAMIL: "தமிழ்",
  ASSAMESE: "অসমীয়া",
  ENGLISH: "English",
  URDU: "اردو",
  SANSKRIT: "संस्कृतम्",
  SINDHI: "سنڌي",
  NEPALI: "नेपाली",
  ORIYA: "ଓଡ଼ିଆ",
};

const _NEWS_TEXT: Record<string, string> = {
  HINDI: "समाचार, ख़बर",
  BENGALI: "খবর",
  MARATHI: "बातम्या",
  GUJARATI: "સમાચાર",
  PUNJABI: "ਖ਼ਬਰਾਂ",
  TAMIL: "செய்திகள்",
  TELUGU: "వార్తలు",
  KANNADA: "ಸುದ್ದಿ",
  MALAYALAM: "വാർത്ത",
  ODIA: "ଖବର",
  ORIYA: "ଖବର",
  ASSAMESE: "বাৰ্তা",
  URDU: "خبریں",
  SANSKRIT: "वार्ताः",
  SINDHI: "خبرون",
  NEPALI: "समाचार",
  ENGLISH: "News",
};

export const VIEW_MORE_TEXT: Record<string, string> = new Proxy(_VIEW_MORE_TEXT, {
  get(target, prop: string) {
    if (prop in target) {
      return target[prop];
    }
    return "Read full story";
  }
});

export const NEWS_TEXT: Record<string, string> = new Proxy(_NEWS_TEXT, {
  get(target, prop: string) {
    if (prop in target) {
      return target[prop];
    }
    return "News";
  }
});

export const LANG_STRING: Record<string, string> = new Proxy(_LANG_STRING, {
  get(target, prop: string) {
    if (prop in target) {
      return target[prop];
    }
    return "Hindi";
  }
});